(function (Drupal) {
  Drupal.behaviors.cardPonenteToggle = {
    attach(context) {
      context.querySelectorAll('.card-ponente .collapse').forEach((collapseEl) => {
        const card = collapseEl.closest('.card-ponente');
        const btnLeerMas = card.querySelector('.btn-leer-mas');
        const btnLeerMenos = collapseEl.querySelector('.btn-leer-menos');

        if (!btnLeerMas || !btnLeerMenos) return;

        collapseEl.addEventListener('show.bs.collapse', () => {
          btnLeerMas.style.display = 'none';
          btnLeerMenos.style.display = '';
        });

        collapseEl.addEventListener('hide.bs.collapse', () => {
          btnLeerMas.style.display = '';
          btnLeerMenos.style.display = 'none';
        });

        btnLeerMenos.style.display = 'none';
      });
    }
  };

  Drupal.behaviors.moveModalsToBody = {
    attach(context) {
      (window.once ? once('move-modals', '.modal', context) : context.querySelectorAll('.modal'))
        .forEach((modal) => {
          if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
          }
        });
    }
  };
  
   Drupal.behaviors.stopVideoOnModalClose = {
    attach(context) {
      (window.once ? once('stop-video', '.modal-video', context) : context.querySelectorAll('.modal-video'))
        .forEach((modal) => {

          modal.addEventListener('hide.bs.modal', () => {
            const iframe = modal.querySelector('iframe');
            const video = modal.querySelector('video');

            if (iframe) {
              iframe.src = iframe.src; 
            }

            if (video) {
              video.pause();
              video.currentTime = 0;
            }
          });
        });
    }
  };

})(Drupal);